/**
 * La marca del sistema: «Treid OPS» y, al costado de la S y a la altura de su base, «PE» chiquito con la bandera de
 * Perú (usuario, 3-nov; primero fue debajo de la S y pidió moverlo al costado). Cuando exista el de Chile irá «CH»: el
 * país es una prop y no texto cableado.
 *
 * La bandera es un SVG y no el emoji 🇵🇪: Windows no dibuja banderas en emoji y mostraría las letras «PE» sueltas.
 * Lleva un borde fino porque su franja blanca desaparece sobre el fondo blanco del menú.
 *
 * `tono="claro"` es para la barra azul del celular: ahí «OPS» no puede ir en azul (azul sobre azul no se lee).
 */
const PAISES = {
  PE: { nombre: 'Perú', bandera: <BanderaPeru /> },
} as const;

type Tamano = 'sm' | 'md' | 'lg';

const TEXTO: Record<Tamano, string> = { sm: 'text-sm', md: 'text-lg', lg: 'text-2xl' };
const PAIS: Record<Tamano, string> = { sm: 'text-[9px]', md: 'text-[10px]', lg: 'text-xs' };

function BanderaPeru() {
  return (
    <svg width="14" height="10" viewBox="0 0 3 2" aria-hidden="true" className="shrink-0 rounded-[1px] ring-1 ring-black/15">
      <rect width="1" height="2" x="0" fill="#D91023" />
      <rect width="1" height="2" x="1" fill="#FFFFFF" />
      <rect width="1" height="2" x="2" fill="#D91023" />
    </svg>
  );
}

export default function MarcaTreidOps({
  tamano = 'md',
  tono = 'oscuro',
  pais = 'PE',
  como: Etiqueta = 'p',
}: {
  tamano?: Tamano;
  tono?: 'oscuro' | 'claro';
  pais?: keyof typeof PAISES;
  /** `h1` en el ingreso, `p` en el menú: el título de la página es la pantalla, no la marca. */
  como?: 'p' | 'h1';
}) {
  const claro = tono === 'claro';
  return (
    <Etiqueta
      aria-label={Etiqueta === 'h1' ? `Treid OPS ${PAISES[pais].nombre}` : undefined}
      className="inline-flex items-baseline gap-1.5 leading-none"
    >
      <span className={`${TEXTO[tamano]} font-bold tracking-tight ${claro ? 'text-white' : 'text-gray-900'}`}>
        Treid <span className={claro ? 'text-white' : 'text-blue-600'}>OPS</span>
      </span>
      <span
        className={`flex items-center gap-1 font-semibold tracking-widest ${PAIS[tamano]} ${
          claro ? 'text-white/90' : 'text-gray-500'
        }`}
      >
        {PAISES[pais].bandera}
        {pais}
      </span>
    </Etiqueta>
  );
}
